module.exports = __webpack_public_path__ + "img/Antartica.a7f61e12.png";